var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "create-view",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      attrs: { "body-style": { height: "100%" } },
    },
    [
      _c(
        "flexbox",
        {
          staticClass: "add-project",
          attrs: { direction: "column", align: "stretch" },
        },
        [
          _c("div", { staticClass: "header" }, [
            _c("span", { staticClass: "text" }, [_vm._v(_vm._s(_vm.title))]),
            _vm._v(" "),
            _c("span", {
              staticClass: "el-icon-close",
              on: { click: _vm.close },
            }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "content" }, [
            _c(
              "div",
              { staticClass: "project-name" },
              [
                _c("div", { staticClass: "label color-label" }, [
                  _vm._v("项目名称"),
                ]),
                _vm._v(" "),
                _c(
                  "el-input",
                  {
                    attrs: { maxlength: 50, placeholder: "请输入内容" },
                    model: {
                      value: _vm.name,
                      callback: function ($$v) {
                        _vm.name = $$v
                      },
                      expression: "name",
                    },
                  },
                  [
                    _c(
                      "i",
                      {
                        staticClass: "el-input__icon",
                        attrs: { slot: "prefix" },
                        slot: "prefix",
                      },
                      [
                        _c("span", {
                          staticClass: "bg-color",
                          style: { background: _vm.typeColor },
                        }),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "color-box" },
                  _vm._l(_vm.typeColorList, function (item, index) {
                    return _c("span", {
                      key: index,
                      style: { background: item },
                      on: {
                        click: function ($event) {
                          _vm.typeColor = item
                        },
                      },
                    })
                  }),
                  0
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "cover" },
              [
                _c("div", { staticClass: "label" }, [_vm._v("项目封面")]),
                _vm._v(" "),
                _c(
                  "flexbox",
                  {
                    staticClass: "cover-content",
                    attrs: { gutter: 0, align: "stretch", wrap: "wrap" },
                  },
                  [
                    _vm._l(_vm.coverImgList, function (item, index) {
                      return _c(
                        "flexbox-item",
                        {
                          key: index,
                          staticClass: "cover-content-item",
                          class: { select: _vm.coverImg.url == item.url },
                          attrs: { span: 0.25 },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.corverSelect(item)
                            },
                          },
                        },
                        [
                          _c("img", {
                            directives: [
                              {
                                name: "src",
                                rawName: "v-src",
                                value: item.url || item.path,
                                expression: "item.url || item.path",
                              },
                            ],
                            staticClass: "cover-img",
                          }),
                          _vm._v(" "),
                          _c("i", {
                            staticClass: "wk wk-success cover-select",
                          }),
                          _vm._v(" "),
                          item.custom && !_vm.coverImg.custom
                            ? _c("i", {
                                staticClass: "wk wk-close cover-delete",
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.corverDelete.apply(
                                      null,
                                      arguments
                                    )
                                  },
                                },
                              })
                            : _vm._e(),
                        ]
                      )
                    }),
                    _vm._v(" "),
                    _vm.coverImgList.length <= 8
                      ? _c(
                          "flexbox-item",
                          {
                            directives: [
                              {
                                name: "loading",
                                rawName: "v-loading",
                                value: _vm.imgLoading,
                                expression: "imgLoading",
                              },
                            ],
                            staticClass: "content-cross",
                            attrs: { span: 0.25 },
                            nativeOn: {
                              click: function ($event) {
                                return _vm.upLoadCustomImg.apply(
                                  null,
                                  arguments
                                )
                              },
                            },
                          },
                          [
                            _c("input", {
                              ref: "imageInput",
                              staticClass: "file-input",
                              attrs: { accept: "image/*", type: "file" },
                              on: { change: _vm.customImgChange },
                            }),
                            _vm._v(" "),
                            _c("el-button", {
                              staticClass: "cross",
                              attrs: { type: "text", icon: "el-icon-plus" },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  2
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "describe" },
              [
                _c("div", { staticClass: "label" }, [_vm._v("项目描述")]),
                _vm._v(" "),
                _c("el-input", {
                  attrs: {
                    rows: 4,
                    maxlength: 300,
                    "show-word-limit": "",
                    type: "textarea",
                    placeholder: "请输入内容",
                  },
                  model: {
                    value: _vm.description,
                    callback: function ($$v) {
                      _vm.description = $$v
                    },
                    expression: "description",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "range" },
              [
                _c("div", { staticClass: "label" }, [_vm._v("可见范围")]),
                _vm._v(" "),
                _c(
                  "el-select",
                  {
                    model: {
                      value: _vm.openType,
                      callback: function ($$v) {
                        _vm.openType = $$v
                      },
                      expression: "openType",
                    },
                  },
                  _vm._l(_vm.openOptions, function (item) {
                    return _c("el-option", {
                      key: item.value,
                      attrs: { label: item.label, value: item.value },
                    })
                  }),
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _vm.openType == 1
              ? _c(
                  "div",
                  { staticClass: "describe" },
                  [
                    _c("div", { staticClass: "label" }, [_vm._v("成员权限")]),
                    _vm._v(" "),
                    _c(
                      "el-select",
                      {
                        model: {
                          value: _vm.ownerRole,
                          callback: function ($$v) {
                            _vm.ownerRole = $$v
                          },
                          expression: "ownerRole",
                        },
                      },
                      _vm._l(_vm.projectRoleList, function (item) {
                        return _c("el-option", {
                          key: item.id,
                          attrs: {
                            label: `${item.title}：${item.remark}`,
                            value: item.id,
                          },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.openType == 0
              ? _c(
                  "div",
                  { staticClass: "member" },
                  [
                    _c("div", { staticClass: "label" }, [_vm._v("项目成员")]),
                    _vm._v(" "),
                    _c(
                      "flexbox",
                      [
                        _vm._l(_vm.selectUserList, function (user, userIndex) {
                          return _c("xr-avatar", {
                            key: userIndex,
                            staticClass: "user-img",
                            attrs: {
                              name: user.realname,
                              size: 25,
                              src: user.img,
                            },
                          })
                        }),
                        _vm._v(" "),
                        _c(
                          "members-dep",
                          {
                            attrs: {
                              "user-checked-data": _vm.selectUserList,
                              "content-block": false,
                              "close-dep": true,
                            },
                            on: { popoverSubmit: _vm.userSelectChange },
                          },
                          [
                            _c("i", {
                              staticClass: "el-icon-plus add-user-btn",
                              attrs: { slot: "membersDep" },
                              slot: "membersDep",
                            }),
                          ]
                        ),
                      ],
                      2
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "footer" },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.submitBtn } },
                [_vm._v("确定")]
              ),
              _vm._v(" "),
              _c("el-button", { on: { click: _vm.close } }, [_vm._v("取消")]),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }